import { getActListId } from '@/views/home/e-cash-coupon/business';
import { CustomException } from '@tencent/ppd-base-libs';
import { CheckActUinRuleRes, CouponInfoItem, checkActUinRule, qryChainCoupInfo, qryCouponInfo } from '@tencent/wphk-act-base-cgi';
import { to } from '@tencent/wphk-base-utils';
import { compact } from 'lodash-es';
import { defineStore } from 'pinia';
import { toRefs } from 'vue';
import { useMerchantInfo } from './merchant-info-module';

export const useECashCouponStore = defineStore('eCashCoupon', {
  state: () => ({
    // 普通券列表
    simpleCouponList: [] as CouponInfoItem[],
    // 连锁券列表
    chainCouponList: [] as CouponInfoItem[],
  }),
  getters: {
  },
  actions: {
    /** 初始化 */
    async init() {
      return Promise.all([this.getSimpleCouponList(), this.getChainCouponList()]);
    },
    /**
     * 获取普通券列表
     */
    async getSimpleCouponList() {
      const { merchantConfig } = toRefs(useMerchantInfo());
      const { simpleCouponList } = merchantConfig.value;
      const actListId = getActListId(simpleCouponList);
      if (actListId.length > 0) {
        const [err, res]  = await to(Promise.all([
          qryCouponInfo({ actListId }),
          checkActUinRule({ checkActList: actListId.map(actListid => ({ actListid })) }),
        ]));
        if (err || !res || !res[0]) {
          new CustomException(err, 'qrySimpleCoupInfoFail', '查询普通券失败');
          return;
        }
        const validActList = this.filterBlockActList(res[0].couponList, res[1]);
        this.simpleCouponList = compact(actListId.map(id => validActList.find(act => act.actListid === id)));
      }
    },
    /**
     * 获取连锁券列表
     */
    async getChainCouponList() {
      const { merchantConfig } = toRefs(useMerchantInfo());
      const { chainCouponList } = merchantConfig.value;
      const actListId = getActListId(chainCouponList);
      if (actListId.length > 0) {
        const [err, res]  = await to(Promise.all([
          qryChainCoupInfo({ actListId }),
          checkActUinRule({ checkActList: actListId.map(actListid => ({ actListid })) }),
        ]));
        if (err || !res || !res[0]) {
          new CustomException(err, 'qryChainCoupInfoFail', '查询连锁券失败');
          return;
        }
        const validActList = this.filterBlockActList(res[0].couponList, res[1]);
        this.chainCouponList = compact(actListId.map(id => validActList.find(act => act.actListid === id)));
      }
    },
    filterBlockActList(couponInfoItem: CouponInfoItem[], uinRuleRes: CheckActUinRuleRes) {
      return couponInfoItem.filter((coupon) => {
        const rule = uinRuleRes.userActInfoList.find(item => item.actListid === coupon.actListid);
        const isValid = rule?.isValid;
        return rule && isValid;
      });
    },
  },
});
